export default __webpack_public_path__ + "static/CommanderPromo-dd9c7c881985e80932db788ec4133e73.mp4";